export default __webpack_public_path__ + "static/media/Netflix.c5991334.png";